import { render } from "./OnCallUser.vue?vue&type=template&id=9f4f7b50&ts=true"
import script from "./OnCallUser.vue?vue&type=script&lang=ts"
export * from "./OnCallUser.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__